import { render, staticRenderFns } from "./fvFormElement.vue?vue&type=template&id=2d3830b4&lang=pug&"
import script from "./fvFormElement.vue?vue&type=script&lang=js&"
export * from "./fvFormElement.vue?vue&type=script&lang=js&"
import style0 from "./fvFormElement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "fvFormElement.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/fvFormElement.vue
// module id = 190
// module chunks = 0 1